 <div class="ldngOvrlyCss">
    <div class="loading-indicator">
      <div class="spinner-2">
         <img src="../../../../assets/images/logo/logo-apcrda.png" alt="Loading..."> 
      </div>
    </div>
</div> 